import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PasswordGate from './components/PasswordGate';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Nutrition from './pages/Nutrition';
import Project from './pages/Project';
import Life from './pages/Life';
import Contact from './pages/Contact';

function App() {
  return (
    <BrowserRouter>
      <PasswordGate>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/nutrition" element={<Nutrition />} />
            <Route path="/project" element={<Project />} />
            <Route path="/life" element={<Life />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </div>
      </PasswordGate>
    </BrowserRouter>
  );
}

export default App;